<template>
  <div
    :class="$style.root"
  >
    <pages-editions-slug-parent-component
      :edition-index="data?.editionIndex"
    />

    <div
      v-if="data?.note"
        :class="$style.note"
      >
      <core-text-component
        :class="$style.noteInner"
        :string="data?.note"
      />
    </div>

    <pages-editions-slug-nav-component
      :has-insights="hasInsights"
      :has-participants="hasParticipants"
      :has-urban-vision="hasUrbanVision"
      :has-education="hasEducation"
      :slug="$route?.params?.slug"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object
})

const hasInsights = true
const hasParticipants = props?.data?.biennialParticipantEntries?.filter(i => i?.names || i?.collectiveName)?.length > 0
const hasUrbanVision = props?.data?.urbanVisionEntry?.id !== undefined
const hasEducation = props?.data?.educationEntries?.length > 0
</script>

<style module>
.root {
  margin-bottom: calc(var(--unit--vertical) * 2);

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 2);
}

.note {
  composes: container from global;

}

.noteInner {
  composes: caption font-size-small from global;
  border-radius: var(--border-radius--default);
  padding: var(--padding--element);

  backdrop-filter: var(--backdrop-filter--dark);
}
</style>
